/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable react/jsx-key */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, Fragment, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import Button from "../../../component/button/Button";
import Card from "../../../component/card/Card";
import HeaderTag from "../../../component/smallComponents/HeaderTag";
import P from "../../../component/smallComponents/P";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Strong from "../../../component/smallComponents/Strong";
import TextInput from "../../../component/input/TextInput";
import { hrActions } from "../../../redux/actions";
import Starter from "../../../component/Starter";
import { helperFunction } from "../../../constant/helper";
import isEmpty from "../../../validation/isEmpty";
import { getReportingMangers } from "../../../redux/actions/hrActions";
import { advancedFilterWorker } from "../../../constant/helper/helper";
import TextInput2 from "../../../component/input/TextInput2";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const AddHod = () => {
  const loginType = localStorage.loginType;

  const dispatch = useDispatch();
  const componentRef = useRef();
  const [workerId, setWorkerId] = useState([]);
  const [reportingManagers, setReportingManagers] = useState([]);
  const [managerDesignation, setManagerDesignation] = useState("");
  const [filterString, setFilterString] = useState("");

  const { hrResponse, hrError, hrLoading, allReportingManagers } =
    useSelector((state) => state.hr);

  useEffect(() => {
    if (hrError) {
      helperFunction.toastHelper("error", hrError);
    }
    if (hrResponse) {
      helperFunction.toastHelper("success", hrResponse);
    }
  }, [hrResponse, hrError]);

  useEffect(() => {
    setTimeout(() => {
      const filter = "ALL";
      dispatch(getReportingMangers(filter, loginType));
    }, 1000);
  }, []);

  useEffect(() => {
    if (!isEmpty(allReportingManagers)) {
      setReportingManagers(allReportingManagers);
    }
  }, [allReportingManagers]);

  const onSubmit = (e) => {
    e.preventDefault();
    const managerObject = {
      workerId,
      managerDesignation
    };

    dispatch(hrActions.setHrLoading(true));
    dispatch(hrActions.clearHrResult());
    dispatch(hrActions.clearHrErrors());
    dispatch(
      hrActions.addReportingManagers(managerObject, loginType)
    );
  };

  useEffect(() => {
    dispatch(hrActions.setHrLoading(false));
    dispatch(hrActions.clearHrResult());
    dispatch(hrActions.clearHrErrors());
    return () => {
      dispatch(hrActions.setHrLoading(false));
      dispatch(hrActions.clearHrResult());
      dispatch(hrActions.clearHrErrors());
    };
  }, []);

  const topInput = (
    <form onSubmit={onSubmit}>
      <div className="row mb-2">
        <div className="col-md-3 mt-2 col-xl-3 col-l-3">
          <TextInput
            type="text"
            required={true}
            textWhite={false}
            value={workerId}
            htmlFor="workerId"
            onChange={(e) => setWorkerId(e.target.value)}
            label="Enter Employee Id"
            placeholder="Enter Employee Id"
          />
        </div>
        <div className="col-md-3 mt-2 col-xl-3 col-l-3">
          <TextInput
            type="text"
            required={true}
            textWhite={false}
            label="Enter Designation"
            value={managerDesignation}
            htmlFor="managerDesignation"
            placeholder="Enter Designation"
            onChange={(e) => setManagerDesignation(e.target.value)}
          />
        </div>

        <div className="form-group text-center col-sm-2 mt-4 col-xl-2 col-lg-2">
          {hrLoading ? (
            <SpinnerButton />
          ) : (
            <Button
              type="submit"
              title="Submit"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark"
            />
          )}
        </div>
      </div>
    </form>
  );

  const showManagerList = (managerArray) => {
    const filteredUser = advancedFilterWorker(
      managerArray,
      filterString,
      "workerId"
    );
    return filteredUser.map((singleUser, index) => {
      return (
        <tr key={index} style={{ fontSize: "12px" }}>
          <td className="">{index + 1}</td>
          <td className="">{singleUser.managerName}</td>
          <td className="">{singleUser.workerId}</td>
          <td className="">{singleUser.managerEmail}</td>
          <td className="">{singleUser.managerDesignation}</td>
        </tr>
      );
    });
  };

  return (
    <Starter
      topBarTitle="Register HOD"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Register Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Registrations</a>
          </li>
          <li className="breadcrumb-item active">Register HOD</li>
        </Fragment>
      }
    >
      <Card>
        <div className="row mb-2">
          <div className="col-sm-8">
            <div className="text-sm-right"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              isClassName={false}
              title="Add HOD"
            />
            <P title="Fill the form below to Register Single HOD Data" />
          </div>
        </div>
        {topInput}
      </Card>
      <Card>
        <div className="row">
          <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
            <TextInput2
              data-tip
              type="text"
              name="filterString"
              value={filterString}
              data-for="filterString"
              placeholder="Search..."
              icon="mdi mdi-table-search"
              onChange={(e) => setFilterString(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div
            ref={componentRef}
            className="table-responsive"
            style={{ height: "700px", overflow: "auto" }}
          >
            <table
              className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
              id="products-datatable"
            >
              <thead className="thead-light">
                <tr>
                  <th style={{ width: "20px" }}>#</th>
                  <th className="">Manager Name</th>
                  <th className="">Manager ID</th>
                  <th className="">Manager Email</th>
                  <th className="">Manager Designation</th>
                </tr>
              </thead>
              <tbody>{showManagerList(reportingManagers)}</tbody>
            </table>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
          <div className="col-2">
            <ReactHTMLTableToExcel
              className="btn btn-dark btn-block"
              table="products-datatable"
              filename="HOD"
              sheet="Sheet"
              buttonText="Export excel"
            />
          </div>
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
        </div>
      </Card>
    </Starter>
  );
};

export default AddHod;
